import { render, staticRenderFns } from "./ItemProfile.vue?vue&type=template&id=4fb02208&scoped=true"
import script from "./ItemProfile.vue?vue&type=script&lang=js"
export * from "./ItemProfile.vue?vue&type=script&lang=js"
import style0 from "./ItemProfile.vue?vue&type=style&index=0&id=4fb02208&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fb02208",
  null
  
)

export default component.exports